import CookieIframe from '#cookie-control/components/CookieIframe.vue'

/**
 * With `isIframeBlocked`, nuxt-cookie-control rewrites every iframe tag in our .vue files into
 * `CookieIframe`, which shows the embed only after the visitor allows functional cookies.
 *
 * The module registers that component through a components dir inside node_modules, but the
 * node_modules and dist globs in the `ignore` list of nuxt.config make Nuxt's component scanner
 * skip it. The tag then resolved to nothing and every embed (Typeform on /vibe, videos, link
 * previews) rendered as an empty element. Registering it here fixes all of them.
 */
export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.component('CookieIframe', CookieIframe)

    // The module's own <CookieControl> banner sets the locale. We render CookieBanner.vue instead,
    // so without this the "blocked embed" placeholder has no text.
    const { locale, cookiesEnabled, cookiesEnabledIds } = useCookieControl()
    if (!locale.value) {
        locale.value = 'sk'
    }

    // A consent stored before our necessary cookie moved from `ncc_f` to `ncc_n` lists `ncc_f`, which
    // the module reads as "functional" (embeds allowed), even for visitors who declined. Until
    // CookieBanner rewrites it on mount, allow embeds only if the visitor had accepted everything.
    const enabledIds = cookiesEnabledIds.value
    const isLegacyConsent = enabledIds && !enabledIds.includes('ncc_n')
    if (isLegacyConsent && !(enabledIds.includes('ga') && enabledIds.includes('marketing'))) {
        cookiesEnabled.value = cookiesEnabled.value?.filter((cookie) => cookie.id !== 'ncc_f')
    }
})
